import React from 'react'

import ppsLogo from '../../images/pps-logo.png'

import * as styles from './Container.m.css'

type Props = {
  children: React.ReactNode | React.ReactNode[]
  width?: string
}

const Container: React.FC<Props> = (props): React.ReactElement => {
  const { children, width } = props

  return (
    <div className={styles.container} style={{ width }}>
      <img src={ppsLogo} className={styles.logo} alt="PPS Logo" />
      <div className={styles.content}>{children}</div>
    </div>
  )
}

export default Container
